// Platform / PWA detection helpers

export const isStandalonePWA = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true; // iOS Safari

export const isIos = () =>
  /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());

export const isAndroid = () =>
  /android/.test(navigator.userAgent.toLowerCase());

// Chromium browsers (Chrome, Edge, Samsung, Opera, Brave) fire
// `beforeinstallprompt`; others like Firefox Android never do and need manual
// install instructions instead.
export const supportsInstallPrompt = () =>
  /chrome/.test(navigator.userAgent.toLowerCase());

// Returns the platform string expected by the push-registerToken backend.
export const getPlatformName = () => {
  if (isIos()) return 'ios';
  if (isAndroid()) return 'android';
  return 'desktop';
};
